import { useUser } from "context/user-context";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { login } from "services/apiAuth";
import { handleApiError } from "utils/errorHandlers";
import { ApiError } from "./ApiError";
import { Button } from "./base/Button";
import { Input } from "./base/Input";

interface LoginFormData {
	email: string;
	password: string;
	remember: boolean;
}

export const ConnexionContent = () => {
  const { setUser } = useUser();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<Record<string, string[]>>({});

	const [loginForm, setLoginForm] = useState<LoginFormData>({
		email: "",
		password: "",
		remember: true,
	})

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value, type, checked } = e.target as HTMLInputElement;
		setLoginForm((prev) => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value,
		}));
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setErrors({});
		try {
			const response = await login({
				email: loginForm.email,
				password: loginForm.password,
			});
			// Mettre à jour le contexte utilisateur avec les données reçues
			if (response.user) {
				setUser(response.user);
				navigate('/');
			}

		} catch (error: any) {
			setErrors(handleApiError(error));
		} finally {
			setLoading(false);
		}
	};


	return (
		<form onSubmit={handleSubmit} className="flex flex-col gap-6">
			<div>
				<Input
					label="Email"
					name="email"
					type="email"
					value={loginForm.email}
					onChange={handleChange}
					required
					width="100%"
					error={errors.email && errors.email[0]}
				/>
			</div>

			<div>
				<Input
					label="Mot de passe"
					name="password"
					type="password"
					value={loginForm.password}
					onChange={handleChange}
					required
					width="100%"
					error={errors.password && errors.password[0]}
				/>
			</div>
			{errors.general && (
				<ApiError>{errors.general[0]}</ApiError>
			)}

			<div className="flex justify-center">
				<Button type="submit" variant="secondary" disabled={loading}>
					{loading ? 'Veuillez patienter...' : 'Se connecter'}
				</Button>
			</div>
		</form>
	)
}